import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { openCalendlyPopup } from '../utils/calendly';
export function FinalCTA() {
  return <section className="py-20 bg-[#0A0E27]" data-id="element-85">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-86">
        <div className="relative rounded-3xl overflow-hidden bg-[#141B3A] border border-[#1E293B] p-8 md:p-16 text-center" data-id="element-87">
          {/* Background Gradient */}
          <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-88">
            <div className="absolute top-[-50%] left-[20%] w-[600px] h-[600px] bg-[#FF5722]/10 rounded-full blur-[100px]" data-id="element-89" />
          </div>

          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-90">
            Bereit, Deinen Vertrieb zu transformieren?
          </h2>
          <p className="text-lg text-[#94A3B8] mb-10 max-w-2xl mx-auto" data-id="element-91">
            Lass uns in einem kostenlosen Erstgespräch analysieren, wie wir Dein
            CRM-System optimieren können.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10" data-id="element-92">
            <div className="flex items-center gap-2 text-[#94A3B8]" data-id="element-93">
              <CheckCircle2 className="w-5 h-5 text-[#FF5722]" data-id="element-94" />
              <span data-id="element-95">Kostenlose Erstberatung (30 Min)</span>
            </div>
            <div className="hidden sm:block text-[#334155]" data-id="element-96">•</div>
            <div className="flex items-center gap-2 text-[#94A3B8]" data-id="element-97">
              <CheckCircle2 className="w-5 h-5 text-[#FF5722]" data-id="element-98" />
              <span data-id="element-99">Konkrete Optimierungsvorschläge</span>
            </div>
            <div className="hidden sm:block text-[#334155]" data-id="element-100">•</div>
            <div className="flex items-center gap-2 text-[#94A3B8]" data-id="element-101">
              <CheckCircle2 className="w-5 h-5 text-[#FF5722]" data-id="element-102" />
              <span data-id="element-103">Keine Verpflichtungen</span>
            </div>
          </div>

          <Button size="lg" className="w-full sm:w-auto text-lg px-10 py-4" rightIcon={<ArrowRight className="w-5 h-5" data-id="element-105" />} onClick={openCalendlyPopup} data-id="element-104">
            Jetzt kostenloses Gespräch buchen
          </Button>

          <p className="mt-6 text-sm text-[#64748B]" data-id="element-106">
            Limitiert auf 5 Gespräche pro Woche für maximale Qualität.
          </p>
        </div>
      </div>
    </section>;
}